import type { PayinsTranslations } from "../interfaces/payins";

export const payinsTranslations: PayinsTranslations = {
  // Countries
  country_BRA: "Brasil",
  country_COL: "Colômbia",
  country_MEX: "México",
  country_ARG: "Argentina",

  // Create page
  create_title: "Receber dinheiro",
  create_subtitle: "Dos seus clientes, de forma rápida e segura",
  button_create: "Criar",
  error_create: "Erro ao criar o payin",
  error_no_org: "Seu usuário não tem uma organização associada, não é possível criar o payin.",

  // Banner linking to the runtime payments activity view
  runtime_banner_text:
    "Procurando suas operações PIX (Brasil), SPEI (México), CBU/CVU (Argentina) ou Bre-B (Colômbia)? Elas são processadas em tempo real e ficam na nova visão de atividade.",
  runtime_banner_link: "Ver atividade de pagamentos",

  // Colombia (Bre-B) runtime payin
  breb_form_hint: "Será gerado um QR Bre-B para o pagador transferir pelo app do banco.",
  breb_success_title: "Pagamento Bre-B criado",
  breb_success_id: "ID",
  breb_success_amount: "Valor a pagar:",
  breb_success_fee: "Taxa",
  breb_success_fee_free: "Sem taxa",
  breb_success_net: "Creditamos",

  qr_panel_expires_in: "Expira em {{time}}",
  qr_panel_expired: "Este QR expirou e não pode mais ser pago. Crie uma nova cobrança.",
  qr_panel_copy_label: "Código para copiar e colar",
  qr_panel_copy_button: "Copiar código",
  qr_panel_copied: "Código copiado",
  breb_success_expires: "Vence em",
  breb_success_copied: "Código copiado",
  breb_success_new: "Criar novo pagamento",
  breb_paid_title: "Pagamento recebido",
  breb_paid_text: "O pagador concluiu a transferência e o valor líquido já está na sua carteira.",
  payin_reversed_title: "Pagamento estornado",
  payin_reversed_text:
    "Este pagamento foi creditado e depois estornado: o valor creditado foi descontado da sua carteira. Você pode criar uma nova cobrança.",
  breb_rejected_text: "O pagamento foi recusado e nada foi creditado. Você pode criar uma nova cobrança.",

  // Shared form fields
  form_payer_name_label: "Nome do pagador",
  form_payer_name_placeholder: "Nome",
  form_payer_last_name_label: "Sobrenome do pagador",
  form_payer_last_name_placeholder: "Sobrenome",
  form_card_number_label: "Número do cartão",
  form_card_number_placeholder: "4111 1111 1111 1111",
  form_expiration_date_label: "Data de expiração (MM/YY)",
  form_expiration_date_placeholder: "MM/YY",
  form_cvv_label: "CVV",
  form_cvv_placeholder: "123",
  form_cuotes_label: "Parcelas",
  form_type_label: "Tipo",
  form_type_amount_sent: "Valor enviado",
  form_type_amount_received: "Valor recebido",
  fee_preview_title: "Resumo",
  fee_preview_fee: "Taxa",
  fee_preview_loading: "Calculando taxa…",
  mode_gross_label: "Quero cobrar",
  mode_net_label: "Quero receber",
  mode_gross_hint: "Digite o que o pagador vai transferir; dizemos quanto fica para você.",
  mode_net_hint: "Digite o que deve cair na sua carteira; dizemos quanto o pagador precisa transferir.",
  derived_net_text:
    "Você recebe {{amount}} {{currency}} na sua carteira, depois de {{fee}} {{currency}} de taxa.",
  derived_gross_text:
    "O pagador precisa transferir {{amount}} {{currency}} para você receber o valor cheio, com {{fee}} {{currency}} de taxa.",
  fee_includes_taxes: "Inclui {{taxes}}.",
  pix_form_hint: "Será gerado um QR Pix para o pagador transferir pelo app do banco.",
  spei_form_hint:
    "Será gerada uma CLABE exclusiva desta cobrança, com vencimento, para o pagador transferir por SPEI pelo banco dele.",
  cbu_cvu_form_hint:
    "As transferências em pesos chegam no seu CVU fixo e são creditadas sozinhas — aqui você só simula a taxa.",
  pse_form_hint:
    "O pagador autoriza o débito na página do próprio banco. Os dados dele precisam ser registrados antes de gerar a cobrança.",
  nequi_form_hint: "A solicitação de cobrança chega ao app Nequi do pagador; ele a aceita pelo celular.",
  bancolombia_button_form_hint:
    "O pagador autoriza o pagamento diretamente no Bancolombia. Os dados dele precisam ser registrados antes de gerar a cobrança.",
  form_payer_rfc_label: "RFC do pagador (opcional)",
  form_payer_rfc_placeholder: "Deixe vazio se não tiver",
  spei_success_title: "Cobrança SPEI criada",
  spei_success_clabe_label: "CLABE desta cobrança",
  spei_success_copy_button: "Copiar CLABE",
  spei_success_hint:
    "Esta CLABE é apenas desta cobrança e expira. O pagador transfere por SPEI pelo banco dele e creditamos assim que chegar.",
  spei_paid_title: "Pagamento creditado",
  spei_paid_text: "A transferência chegou e o valor líquido já está na sua carteira.",
  spei_rejected_text: "O pagamento foi rejeitado e nada foi creditado. Você pode criar uma nova cobrança.",
  panel_account_title: "Sua conta para receber",
  panel_account_copy: "Copiar",
  panel_account_copied: "Copiado",
  panel_simulator_title: "Simule a taxa",
  panel_corridor_unavailable:
    "Este corredor ainda não está habilitado para a sua organização. Fale com o seu executivo de conta.",
  corridor_unavailable_tooltip:
    "Corredor ainda não habilitado. Fale com o seu executivo de conta para ativá-lo.",
  simulator_gross_hint: "Digite o que vão transferir para você; dizemos quanto fica para você.",
  simulator_net_hint: "Digite o que deve cair na sua carteira; dizemos quanto precisam transferir para você.",
  submit_gross: "Criar cobrança por este valor",
  submit_net: "Criar cobrança para receber este valor",
  form_amount_label: "Valor",
  form_amount_usd_label: "Valor (USD)",
  form_payer_document_label: "CPF/CNPJ do pagador",
  form_payer_document_placeholder: "Somente números (11 ou 14 dígitos)",
  form_description_label: "Descrição",
  form_description_placeholder: "Nota opcional",

  // Colombia form fields
  form_method_label: "Método de pagamento",
  form_method_placeholder: "Selecione um método",
  form_document_type_label: "Tipo de documento",
  form_document_type_placeholder: "Selecione um tipo",
  form_document_label: "Número do documento",
  form_document_placeholder: "1234567890",
  form_email_label: "Email",
  form_email_placeholder: "usuario@email.com",
  form_phone_label: "Telefone",
  form_phone_placeholder: "+57 300 000 0000",
  form_bank_label: "Banco",
  form_bank_placeholder: "Selecione um banco",
  form_nequi_phone_label: "Número Nequi",

  // USA form / file upload
  form_receipt_label: "Comprovante",
  upload_instruction: "Clique para enviar ou arraste aqui",
  upload_instruction_drop: "Solte o arquivo aqui",
  upload_helper: "Envie um comprovante da transação.",
  upload_constraints: "Máximo 10 MB • Imagens (JPG, PNG, WebP)",
  upload_change: "Alterar",
  upload_remove: "Remover",
  upload_preview_alt: "Pré-visualização do comprovante",

  // Mexico runtime deposit panel (push-detected SPEI — no user-initiated create)

  // Argentina runtime deposit panel (push-detected CBU/CVU — no user-initiated create)
  arg_panel_instructions_title: "Deposite por transferência (CBU/CVU)",
  arg_panel_instructions_body:
    "Sua organização tem um CVU de depósito atribuído. Faça uma transferência em pesos argentinos do seu banco ou carteira — você define o valor — e os fundos serão creditados automaticamente quando o depósito for confirmado.",
  arg_panel_cvu_hint: "Não conhece seu CVU de depósito? Solicite ao seu executivo de conta.",
  arg_panel_deposits_title: "Depósitos recentes",
  arg_panel_deposits_empty: "Ainda não registramos depósitos.",
  arg_panel_refresh_aria: "Atualizar depósitos",
  arg_panel_status_processing: "Em processamento",
  arg_panel_status_credited: "Creditado",
  arg_panel_status_failed: "Rejeitado",

  // Validation
  validation_payer_name_required: "O nome do pagador é obrigatório",
  validation_payer_name_max: "O nome não pode exceder 100 caracteres",
  validation_amount_positive: "O valor deve ser maior que 0",
  validation_payer_document: "Informe um CPF (11 dígitos) ou CNPJ (14 dígitos) válido",
  validation_name_required: "O nome é obrigatório",
  validation_last_name_required: "O sobrenome é obrigatório",
  validation_card_number_required: "O número do cartão é obrigatório",
  validation_expiration_date_required: "A data de expiração é obrigatória",
  validation_cvv_required: "O CVV é obrigatório",
  validation_cuotes_positive: "O número de parcelas deve ser maior que 0",
  validation_card_number_invalid: "Número do cartão inválido",
  validation_expiration_date_invalid: "Data de expiração inválida (MM/YY)",
  validation_expiration_date_past: "O cartão está vencido",
  validation_cvv_invalid: "CVV inválido",
  validation_method_required: "O método de pagamento é obrigatório",
  validation_document_type_required: "O tipo de documento é obrigatório",
  validation_document_required: "O número do documento é obrigatório",
  validation_email_invalid: "O email não é válido",
  validation_phone_required: "O telefone é obrigatório",
  validation_description_required: "A descrição é obrigatória",
  validation_bank_required: "O banco é obrigatório para PSE",
  validation_nequi_phone_required: "O número Nequi é obrigatório",
  validation_voucher_required: "O comprovante é obrigatório",
  // Return page (/app/payins/result) — chegada após o fluxo bancário PSE
  return_breadcrumb: "Resultado do pagamento",
  return_missing_title: "Pagamento não encontrado",
  return_missing_body: "O link não inclui um pagamento válido. Verifique a atividade de pagamentos.",
  return_waiting_title: "Processando seu pagamento…",
  return_waiting_body:
    "O banco está confirmando a transação. Esta página atualiza sozinha; pode levar alguns minutos.",
  return_confirmed_title: "Pagamento confirmado!",
  return_confirmed_body: "O dinheiro foi creditado na wallet",
  return_rejected_title: "Pagamento rejeitado",
  return_rejected_body: "A transação foi rejeitada ou falhou no banco. Nenhum saldo foi creditado.",
  return_go_wallets: "Ir para wallets",
  return_pse_processing_title: "Processando pagamento",
  return_pse_pending_callout:
    "Sua transação está PENDENTE. Verifique se o débito foi realizado no banco. Para dúvidas, entre em contato pelo telefone {{phone}} ou pelo e-mail {{email}}",
  return_pse_autoupdate:
    "Esta página será atualizada automaticamente. Você também pode fechar a janela se desejar; a transação será confirmada assim que o pagamento for confirmado.",
  return_pse_info_cus: "CUS",
  return_pse_info_bank: "Banco",
  return_pse_info_amount: "Valor",
  return_pse_info_detail: "Detalhe",
  return_pse_info_reference: "Referência",
  return_pse_rejected_body: "A transação não pôde ser processada. Você pode tentar novamente.",
  return_pse_success_title: "Pagamento bem-sucedido",
  return_pse_success_body:
    "Sua transação foi processada. Você receberá uma notificação de confirmação nas próximas 24 horas.",
  return_pse_retry: "Tentar novamente",
  return_pse_home: "Voltar ao início",
  pse_contact_phone: "+57 310 8343446",
  pse_contact_email: "operations@colocapayments.com",
  pse_contact_phone_label: "Telefone",
  pse_contact_email_label: "E-mail",

  // Colombia collection flow — shared by /app/payins (Colombia tab) and the COP wallet deposit modal
  step_amount: "Valor",
  step_payer: "Pagador",
  step_confirm: "Confirmar",
  button_continue: "Continuar",
  button_back: "Voltar",
  submit_pse: "Criar cobrança PSE",
  submit_payer_rail: "Criar cobrança",
  nequi_waiting_title: "A solicitação já está no app do pagador",
  nequi_waiting_body:
    "Enviamos a cobrança para o número {{phone}}. O pagador precisa aceitá-la no app Nequi.",
  nequi_waiting_live: "Aguardando a confirmação… você pode deixar esta janela aberta.",
  nequi_waiting_new: "Criar outra cobrança",
  rail_confirmed_title: "Pagamento creditado",
  rail_confirmed_body: "O pagador aceitou a solicitação e o líquido já está na sua carteira.",
  rail_confirmed_new: "Criar outra cobrança",
  rail_failure_title: "Não foi possível concluir a cobrança",
  rail_failure_generic: "A cobrança não foi concluída e nada foi creditado. Você pode criar uma nova.",
  rail_failure_retry: "Criar outra cobrança",
  method_choice_label: "Como vai pagar?",
  method_breb_desc: "Transfere pelo app do banco escaneando um QR.",
  method_pse_title: "PSE",
  method_pse_desc: "Autoriza o débito na página do próprio banco. Confirma sozinho.",
  method_nequi_desc: "Recebe a solicitação de cobrança no app Nequi e a aceita pelo celular.",
  method_bancolombia_desc: "Autoriza o pagamento diretamente no Bancolombia. Confirma sozinho.",
  method_unavailable: "Ainda não disponível para a sua organização.",
  method_temporarily_disabled: "Em manutenção. Esperamos tê-lo ativo em breve.",
  amount_limit_hint_range: "Entre {{min}} e {{max}} por operação.",
  amount_limit_hint_max: "Até {{max}} por operação.",
  amount_limit_hint_min: "A partir de {{min}} por operação.",
  amount_limit_hint_by_payer: "Até {{person}} para pessoas físicas e {{company}} para empresas.",
  amount_limit_above: "O valor excede o máximo permitido de {{max}}.",
  amount_limit_below: "O valor está abaixo do mínimo de {{min}}.",
  method_limit_up_to: "Até {{max}}.",
  method_limit_up_to_by_payer: "Até {{person}} (pessoas) · {{company}} (empresas).",
  confirm_limit_above: "Para {{payer}} o máximo por operação é {{max}}. Ajuste o valor para continuar.",
  confirm_limit_below: "Para {{payer}} o mínimo por operação é {{min}}. Ajuste o valor para continuar.",
  confirm_limit_edit_amount: "Editar valor",
  limit_payer_person: "pessoas físicas",
  limit_payer_company: "empresas",
  confirm_amount: "O pagador envia",
  confirm_net: "Creditamos",

  // PSE payer form
  pse_voucher_amount_label: "A pagar",
  pse_voucher_reference_label: "Referência",
  pse_voucher_copy: "Copiar referência",
  pse_voucher_copied: "Referência copiada",
  pse_group_identity: "Quem paga",
  pse_group_contact: "Contato e banco",
  pse_person_type_label: "Tipo de pessoa",
  pse_person_natural: "Pessoa física",
  pse_person_juridica: "Empresa",
  pse_document_type_label: "Tipo",
  pse_document_number_label: "Número do documento",
  pse_document_placeholder: "Somente números",
  pse_document_invalid: "Digite um documento de 4 a 15 dígitos",
  pse_name_label: "Nome completo",
  pse_name_placeholder: "Como aparece no documento",
  pse_email_label: "E-mail",
  pse_email_placeholder: "email@exemplo.com",
  pse_email_invalid: "Digite um e-mail válido",
  pse_phone_label: "Celular",
  pse_phone_placeholder: "3001234567",
  pse_phone_invalid: "Digite um celular colombiano de 10 dígitos começando por 3",
  mobile_phone_invalid: "Digite um celular de 10 dígitos começando por 3",
  pse_address_label: "Endereço",
  pse_address_placeholder: "Calle 100 # 10-20, Bogotá",
  pse_bank_label: "Banco",
  pse_bank_placeholder: "Busque o seu banco",
  pse_bank_loading: "Carregando bancos…",
  pse_bank_empty: "Nenhum banco corresponde",
  pse_bank_error: "Não foi possível carregar a lista de bancos.",
  pse_bank_retry: "Tentar novamente",
  pse_bank_hint: "Levamos você à página do banco para autorizar o débito.",
  pse_max_length: "Máximo de {{max}} caracteres",

  // PSE handoff to the bank, and the failure that stops it
  pse_handoff_title: "Criando a transação",
  pse_handoff_body: "Estamos preparando o pagamento com o banco. Não feche esta janela.",
  pse_handoff_cancel: "Cancelar",
  pse_failure_title: "Não conseguimos criar o pagamento",
  pse_failure_limit:
    "O valor da transação excede os limites estabelecidos. Entre em contato com nossos canais de atendimento.",
  pse_failure_generic:
    "Não foi possível criar a transação. Tente mais tarde ou entre em contato com nossos canais de atendimento.",
  pse_failure_retry: "Tentar novamente",
  pse_confirmed_title: "Pagamento creditado",
  pse_confirmed_body: "O pagador autorizou o débito e o valor líquido já está na sua carteira.",
  pse_confirmed_new: "Criar outra cobrança",

  // Own Bre-B key and the QR placard
  qr_card_title: "Pague com {{rail}}",
  qr_card_hint: "Escaneie pelo app do seu banco",
  qr_card_amount_label: "Valor a pagar",
  qr_card_share: "Compartilhar",
  qr_card_download: "Baixar",
  qr_card_key_label: "ou transfira para a chave",
  breb_key_label: "Sua chave Bre-B",
  breb_key_copy: "Copiar chave",
  breb_key_copied: "Chave copiada",
  breb_key_copy_error: "Não conseguimos copiar. Selecione a chave e copie manualmente.",
  breb_key_share: "Compartilhar",
  breb_key_share_text: "Transfira para mim pelo Bre-B para a chave {{key}} pelo app do seu banco.",
  breb_key_holder_hint: "O app do banco mostrará “{{name}}” como destinatário.",
  breb_key_pending_title: "Estamos terminando de registrar sua chave",
  breb_key_pending_body:
    "O Bre-B está confirmando. Costuma levar alguns segundos; você pode fechar esta janela e voltar depois.",
  breb_key_howto_title: "Como recarregar com sua chave?",
  breb_key_howto_step1: "Copie sua chave.",
  breb_key_howto_step2: "Abra o app do seu banco e escolha transferir com chave Bre-B.",
  breb_key_howto_step3:
    "Cole a chave, digite o valor e confirme. O dinheiro chega à sua carteira COP em segundos.",
  breb_key_qr_title: "Sua chave e suas cobranças com valor",
  breb_key_qr_body:
    "Para uma cobrança com valor, compartilhe o QR dessa cobrança: uma transferência digitada para sua chave chega à sua carteira, mas como um recebimento separado, e a cobrança fica sem pagamento.",
  breb_key_qr_fallback:
    "Se você excluir uma chave, deixará de receber nela e no QR para qualquer valor dela. Se era sua chave principal, suas próximas cobranças com valor usarão a seguinte, ou a chave geral da Coloca se não restar nenhuma.",
  breb_key_compact_create: "Crie sua chave Bre-B",
  breb_key_compact_create_hint: "Receba sem QR, de qualquer banco",
  breb_key_entry_cta_view: "Ver como recarregar",
  breb_key_bounds_rule_label: "O que acontece fora deste intervalo",
  breb_key_bounds_rule_range:
    "Se alguém enviar menos de {{min}} ou mais de {{max}}, o pagamento vai falhar. Vale para a sua chave e o seu QR.",
  breb_key_bounds_rule_min:
    "Se alguém enviar menos de {{min}}, o pagamento vai falhar. Vale para a sua chave e o seu QR.",
  breb_key_bounds_rule_max:
    "Se alguém enviar mais de {{max}}, o pagamento vai falhar. Vale para a sua chave e o seu QR.",
  breb_key_entry_or_amount: "Ou crie uma cobrança com valor",
  breb_key_wizard_step_intro: "O que é",
  breb_key_wizard_step_choose: "Sua chave",
  breb_key_wizard_step_confirm: "Confirmar",
  breb_key_intro_title: "Receba dinheiro sem QR",
  breb_key_intro_body:
    "Sua chave Bre-B funciona como um apelido da sua carteira COP. Quem paga digita a chave no app do banco e o dinheiro chega em segundos. Como não há nada para escanear, funciona pelo mesmo celular.",
  breb_key_intro_point_banks: "De qualquer banco ou carteira do país, 24/7.",
  breb_key_intro_point_uses: "Serve para recarregar sua carteira ou para seus clientes pagarem você.",
  breb_key_intro_point_qr:
    "Você também terá um QR para qualquer valor, pronto para imprimir ou compartilhar.",
  breb_key_intro_cta: "Escolher minha chave",
  breb_key_choose_title: "Escolha sua chave",
  breb_key_choose_body: "É assim que quem paga vai digitar. Sempre começa com @coloca.",
  breb_key_option_document: "Com seu documento",
  breb_key_option_document_hint: "Inclui o número do seu documento: quem receber sua chave vai vê-lo.",
  breb_key_option_phone: "Com seu celular",
  breb_key_option_phone_verified_hint:
    "É o celular que você registrou ao verificar sua conta: quem receber sua chave vai vê-lo.",
  breb_key_option_generated: "Chave atribuída",
  breb_key_option_generated_hint: "Geramos uma chave única para sua conta.",
  breb_key_availability_available: "Disponível",
  breb_key_availability_taken: "Já está em uso",
  breb_key_availability_unknown: "Não conseguimos verificar",
  breb_key_availability_checking: "Verificando…",
  breb_key_availability_recheck: "Verificar de novo",
  breb_key_taken_in_coloca: "Outra organização da Coloca já a registrou. Se for sua, fale com o suporte.",
  breb_key_taken_in_coloca_notified:
    "Outra organização da Coloca já a registrou. Avisamos por e-mail; se for sua, fale com o suporte.",
  breb_key_taken_elsewhere:
    "Já está registrada em outra instituição do Bre-B. Se for sua, fale com o suporte.",
  breb_key_all_taken_title: "Todas as suas opções de chave já estão registradas",
  breb_key_all_taken_body:
    "Abaixo você vê onde cada uma está registrada. Se alguma for sua, fale com o suporte.",
  breb_key_choose_cta: "Continuar",
  breb_key_confirm_title: "Confirme sua chave",
  breb_key_confirm_permanent: "Ela fica até você excluí-la. Se excluir, pode criar outra.",
  breb_key_delete: "Excluir chave",
  breb_key_delete_title: "Excluir a chave {{key}}?",
  breb_key_delete_body:
    "Você deixará de receber transferências para {{key}} e pagamentos pelo seu QR para qualquer valor. Suas próximas cobranças com valor usarão a chave geral da Coloca, e depois você poderá criar uma nova chave.",
  breb_key_delete_body_final:
    "Você deixará de receber transferências para {{key}} e pagamentos pelo seu QR para qualquer valor. Suas próximas cobranças com valor usarão a chave geral da Coloca. Para voltar a ter uma chave própria, fale com o suporte.",
  breb_key_delete_confirm: "Excluir chave",
  breb_key_delete_anyway: "Excluir mesmo assim",
  breb_key_delete_cancel: "Cancelar",
  breb_key_delete_done: "Você excluiu a chave {{key}}.",
  breb_key_delete_two_factor_required: "Ative a verificação em duas etapas para excluir a chave.",
  breb_key_delete_two_factor_description:
    "Digite o código do seu app autenticador para excluir a chave {{key}}.",
  breb_key_confirm_qr: "Enquanto existir, seus QR de cobrança vão usá-la.",
  breb_key_confirm_cta: "Criar minha chave",
  breb_key_creating: "Registrando sua chave no Bre-B…",
  breb_key_back: "Voltar",
  breb_key_close: "Fechar",
  breb_key_ready_title: "Sua chave está pronta!",
  breb_key_ready_body: "Copie ou compartilhe e receba de qualquer banco.",
  breb_key_error_title: "Não conseguimos criar sua chave",
  breb_key_retry: "Tentar novamente",
  breb_key_load_error: "Não conseguimos carregar sua chave Bre-B.",
  breb_key_verify_title: "Verifique sua conta para criar sua chave",
  breb_key_verify_body:
    "A chave recebe dinheiro de qualquer banco em nome da sua organização, por isso exigimos a conta verificada.",
  breb_key_verify_cta: "Verificar minha conta",
  breb_key_rail_disabled: "As cobranças Bre-B não estão disponíveis para sua organização no momento.",
  breb_key_not_enabled: "A chave Bre-B ainda não está disponível para a sua conta.",
  breb_key_no_options: "Não encontramos dados para montar sua chave. Fale com o suporte.",
  breb_key_read_only:
    "Sua organização ainda não tem chave Bre-B. Peça a um administrador da sua conta para criá-la.",
  breb_key_availability_unknown_body:
    "Não conseguimos confirmar se esta chave está livre. Verifique de novo em alguns segundos.",
  breb_key_choose_other: "Escolher outra chave",
  breb_key_choice_gone: "Essa chave não está mais disponível. Volte e escolha outra.",
  breb_key_create_amount_charge: "Criar uma cobrança com valor",
  breb_key_bounds_title: "Valores que sua chave recebe",
  breb_key_bounds_min: "Valor mínimo",
  breb_key_bounds_max: "Valor máximo",
  breb_key_bounds_hint:
    "O banco de quem paga recusa transferências fora deste intervalo antes de enviar o dinheiro.",
  breb_key_static_qr_title: "Seu QR para qualquer valor",
  breb_key_static_qr_body:
    "Imprima ou compartilhe: quem escanear digita o valor no app do banco e o dinheiro chega à sua carteira COP.",
  breb_key_static_qr_generating: "Estamos gerando seu QR. Ele vai aparecer aqui em alguns segundos.",
  breb_key_pending_badge: "Em registro",
  breb_key_last_failure_title: "Sua chave não foi registrada",
  breb_key_last_failure_taken: "A chave {{key}} já estava em uso em outra instituição. Escolha outra opção.",
  breb_key_last_failure_rejected: "O Bre-B não aceitou a chave {{key}}. Escolha outra opção.",
  breb_key_last_failure_unfinished:
    "Não conseguimos concluir o registro da chave {{key}}. Tente novamente ou fale com o suporte.",
  breb_key_last_failure_custom_taken:
    "A chave {{key}} já estava em uso em outra instituição. Fale com o suporte se quiser outra chave personalizada.",
  breb_key_last_failure_custom_rejected:
    "O Bre-B não aceitou a chave {{key}}. Fale com o suporte se quiser outra chave personalizada.",
  breb_key_last_failure_custom_unfinished:
    "Não conseguimos concluir o registro da chave {{key}}. Fale com o suporte para revisá-la.",
  breb_key_primary_label: "Sua chave principal",
  breb_key_entry_more: "+{{count}}",
  breb_key_entry_more_label: "Chaves adicionais: {{count}}",
  breb_key_list_title: "Suas chaves",
  breb_key_list_hint:
    "Suas cobranças com valor usam a chave principal. Ao criar uma cobrança, você pode escolher outra.",
  breb_key_list_add: "Adicionar outra chave",
  breb_key_primary_badge: "Principal",
  breb_key_source_document: "Documento",
  breb_key_source_phone: "Celular",
  breb_key_source_generated: "Atribuída",
  breb_key_source_custom: "Personalizada",
  breb_key_set_primary: "Usar como principal",
  breb_key_set_primary_done: "{{key}} agora é sua chave principal.",
  breb_key_delete_body_primary:
    "Você deixará de receber transferências para {{key}} e pagamentos pelo QR para qualquer valor dela. Suas próximas cobranças com valor usarão {{next}}, que passa a ser sua chave principal.",
  breb_key_delete_body_secondary:
    "Você deixará de receber transferências para {{key}} e pagamentos pelo QR para qualquer valor dela. Sua chave principal não muda.",
  breb_key_add_cancel: "Cancelar",
  breb_key_add_none: "Você já tem todas as chaves que os dados da sua conta permitem.",
  breb_key_options_load_error: "Não conseguimos carregar as opções de chave.",
  breb_key_confirm_qr_secondary:
    "Suas cobranças com valor continuarão usando sua chave principal. Você pode trocá-la quando quiser.",
  breb_key_select_label: "Chave que recebe o pagamento",
  breb_key_select_hint: "O QR da cobrança é gerado sobre esta chave.",
  breb_key_select_option_primary: "{{source}} · Principal",
  payin_detail_receiving_key: "Chave que recebeu",
  payin_detail_channel: "Como chegou",
  payin_detail_channel_qr: "Código QR",
  payin_detail_channel_key_unnamed: "Transferência para sua chave Bre-B",
  payin_detail_channel_static_qr: "QR para qualquer valor",
  payin_detail_payer: "Pagador",
  payin_detail_sent: "Enviado pelo pagador",
  payin_detail_fee: "Comissão",
  payin_detail_credited: "Creditado",

  breb_key_show_qr: "Ver QR",
  breb_key_quick_title: "Suas chaves Bre-B",
  breb_key_quick_hint: "Compartilhe-as para receber de qualquer banco, no valor que quiserem enviar.",
  breb_key_quick_manage: "Gerenciar",
  breb_key_qr_view_title: "QR da sua chave",
  breb_key_qr_view_details: "Ver detalhes da chave",
  breb_key_payment_received_title: "Pagamento recebido",
  breb_key_payment_received_announce: "Chegou um pagamento de {{amount}}",
  breb_key_payment_received_from: "De {{name}}",
  breb_key_payment_received_credited: "Chegam {{amount}} à sua carteira depois da taxa.",
  breb_key_payment_received_view: "Ver transação",
  breb_key_payment_received_view_short: "Ver",
  breb_key_payment_received_earlier: "Também chegaram",
  breb_key_payment_listening: "Avisamos aqui assim que chegar um pagamento.",
  breb_key_payment_listening_more: "Avisamos aqui se chegar outro.",
  breb_key_payment_sound_mute: "Silenciar o som de pagamentos",
  breb_key_payment_sound_unmute: "Ativar o som de pagamentos",
};
